import countryInformationApisClient from '@/services/country-information';

class Currencies {
  fetchCurrencies = async () => {
    const response = await countryInformationApisClient.get(`/currencies`);
    return response.data;
  };
}

export const CurrenciesInstance = new Currencies();
